import queryString from 'query-string';
import { ajaxSend } from '../../../api/api';
const base = '/v3/conversations';
function addParam(key, value, params, allowBool = false) {
    const param = [];
    if (typeof value === 'string' || (allowBool && typeof value === 'boolean')) {
        param.push(`${key}=${value}`);
    }
    else if (typeof value === 'object') {
        for (let i = 0; i < value.length; i++) {
            param.push(`${key}=${value[i]}`);
        }
    }
    param.length > 0 && params.push(param.join('&'));
}
export function getConversations(payload) {
    let path = '';
    if (payload) {
        const { channel, query, page_number, page_size, status, queue, assigned, requester, agent, direction, } = payload;
        /*
        Currently the Dashboard shows awaitingpending as open conversations
        So if we see open as part of our filter, we will make sure to include awaitingpending also
        */
        let enrichedStatus = status;
        if (status === 'open') {
            enrichedStatus = ['open', 'awaitingpending'];
        }
        else if (Array.isArray(status) &&
            status.includes('open') &&
            !status.includes('awaitingpending')) {
            enrichedStatus = [...status, 'awaitingpending'];
        }
        if (query && typeof query.path === 'string') {
            path = query.path;
        }
        else {
            const pathParams = [];
            addParam('channel', channel, pathParams);
            addParam('status', enrichedStatus, pathParams);
            addParam('queue', queue, pathParams);
            addParam('assigned', assigned, pathParams, true);
            addParam('agent', agent, pathParams, false);
            addParam('requester', requester, pathParams);
            addParam('direction', direction, pathParams);
            addParam('page_number', page_number, pathParams);
            addParam('page_size', page_size, pathParams);
            // Build the path.
            path = `?${pathParams.join('&')}`;
        }
        // We replace the first char with a "?" if it's a "&".
        if (path !== '' && path.indexOf('&') === 0) {
            path = path.substring(1);
            path = `?${path}`;
        }
    }
    const request = {
        path: `${base}${path}`,
    };
    return ajaxSend(request).then((data) => {
        return Object.assign({}, data, { current_page: `${request.path}` });
    });
}
export function getConversationMessages(payload) {
    const { csid } = payload;
    if (!csid) {
        console.warn('API call getConversationMessages: No csid given');
        return Promise.reject();
    }
    const path = `/v1/conversations/${csid}/messages`;
    return ajaxSend({
        path,
    });
}
export function getConversationBulkIDs(payload) {
    const { queryFilter } = payload;
    const path = '/v3/conversations/bulk/ids';
    const qs = queryString.stringify(queryFilter);
    return ajaxSend({
        path: `${path}?${qs}`,
    });
}
export function getConversationBulkIDsByCSIDs(payload) {
    const path = '/v3/conversations/bulk/validation';
    return ajaxSend({
        method: 'POST',
        path,
        data: payload,
    });
}
